"use strict";

import "./Popup.css";
import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";

export default class Popup extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			shown: this.props.shown
		};
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.shown != this.props.shown) {
			this.setState({
				shown: nextProps.shown
			});
		}
	}
	
	componentDidMount() {
		this.popup = document.createElement("div");
		document.body.appendChild(this.popup);
		this.renderLayer();
	}
	
	componentDidUpdate() {
		this.renderLayer();
	}
	
	componentWillUnmount() {
		ReactDOM.unmountComponentAtNode(this.popup);
		document.body.removeChild(this.popup);
	}
	
	renderLayer() {
		const className = classnames("Popup", this.props.className, {"Shown": this.state.shown});
		if (className !== this.popup.className) {
			this.popup.className = className;
			//this.popup.classList.add(...className.split(" ")); //bugos ie11 alatt
		}
			
		if (this.props.children)
			ReactDOM.render(this.props.children, this.popup);
	}
	
	render() {
		// Render a placeholder
		return <div/>;
	}
}

Popup.propTypes = {
	shown: React.PropTypes.bool
};

Popup.defaultProps = {
	shown: false
};


// WEBPACK FOOTER //
// ./~/vwa/components/Popup/Popup.jsx